export interface Environment {
    production: boolean;
    instana: boolean;
    env: string;
    legalAppIdEndCustomer: string;
    legalAppIdCustomer: string;
    statusPageAppId: string;
    http: {
        registerBaseUrl: string;
        userManagementBaseUrl: string;
        companiesBaseUrl: string;
        companyV2BaseUrl: string;
        companyBaseUrl: string;
        legalBaseUrl: string;
        usersBaseUrl: string;
        usersV2BaseUrl: string;
        translationsBaseUrl: string;
        statusPageBaseUrl: string;
        viCareBaseUrl: string;
        purchasesBaseUrl: string;
        monetizationBaseUrl: string;
        notificationBaseUrl: string;
        apiBaseUrl: string;
        invitationBaseUrl: string;
    };
    IAMConfig: {
        auth: {
            baseUrl: string;
            appId: string;
        };
    };
    allowedPhoneCountryCodes: string[];
    globalHeader: {
        baseUrl: string;
        accountAppUrl: string;
        partnerPortalBaseUrl: string;
    };
    forbiddenCountries: {
        // Vkorg
        contacts: string[];
        notifications: string[];
        rolesAndPermissions: string[];
    };
    allowedServiceCaseCountryCodes: string[];
    allowedNotificationSalesOrgs: string[];
    allowedPersonalNotificationSalesOrgs: string[];
    reCaptchaSiteKey: string;
    baseUrl: string;
    viessmannHome: string;
    ekCountriesWithBankAccountManagement: string[];
    forbiddenLiteCountryCodes: string[];
    employeeSelfServiceUrl: string;
}

// while the api gateway operates in a hybrid mode and both domains are supported, it is deemed necessary to adjust the remote url in regard to the used domain
export function replaceDomainUrl(url: string) {
    const base = window.location.hostname.split('.')[1];
    return base === 'viessmann' ? url.replace('viessmann-climatesolutions.com', 'viessmann.com') : url;
}
